var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveClaimChartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M6.938 19.875v-5.063c0-.62.503-1.124 1.125-1.124h7.874c.622 0 1.126.503 1.126 1.124v5.626m0-16.313v2.25c0 .621-.504 1.125-1.125 1.125H8.061a1.125 1.125 0 0 1-1.124-1.125V3m13.497 3.935-3.37-3.37A1.929 1.929 0 0 0 15.7 3H4.93A1.929 1.929 0 0 0 3 4.929V19.07C3 20.137 3.863 21 4.929 21H19.07A1.929 1.929 0 0 0 21 19.071V8.3c0-.512-.203-1.002-.565-1.364Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveClaimChartIcon);
export default __webpack_public_path__ + "static/media/save-claim-chart-icon.cb064c8d76a16569e0df22b64f8051c9.svg";
export { ForwardRef as ReactComponent };